import { Report19201 } from "../../../components/borrowSystem/Report/Report19201";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report19201Container() {
  const titleName = "รายงานการชำระเงินกู้ยืมกองทุนพัฒนาฝีมือแรงงาน";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report19201 />
      <Footer />
    </div>
  );
}
